import styled from 'styled-components'

const PaginationUi = styled.div`
  margin-top: 40px;
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
`

export default PaginationUi
